import { LayoutGrid, List, Rows3 } from "lucide-react";

import type { ViewMode } from "../lib/view-mode";

export function ViewModeToggle({
  value,
  onChange,
}: {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}) {
  return (
    <div className="view-mode-toggle" role="group" aria-label="Visualizzazione elenco">
      <button
        type="button"
        aria-label="Cubi"
        aria-pressed={value === "cubes"}
        onClick={() => onChange("cubes")}
      >
        <LayoutGrid size={17} />
        <span>Cubi</span>
      </button>
      <button
        type="button"
        aria-label="Rettangoli"
        aria-pressed={value === "rectangles"}
        onClick={() => onChange("rectangles")}
      >
        <Rows3 size={18} />
        <span>Rettangoli</span>
      </button>
      <button
        type="button"
        aria-label="Lista"
        aria-pressed={value === "list"}
        onClick={() => onChange("list")}
      >
        <List size={18} />
        <span>Lista</span>
      </button>
    </div>
  );
}
